import React, { memo } from "react";
import { Route, Switch } from "react-router-dom";
import PropTypes from "prop-types";

import CustomersDisplay from "./Display.jsx";
import Customer from "../Details/Customer.jsx";

const Customers = memo(({ match }) => {
	return (
		<Switch>
			<Route path={`${match.url}/:id`} component={Customer} />
			<Route exact path={`${match.url}`} component={CustomersDisplay} />
		</Switch>
	);
});
Customers.displayName = `Customers`;
Customers.propTypes = {
	match: PropTypes.object.isRequired
};

export default Customers;
